import axios from 'axios';

export function findCompany(text, withRealCompanies = false, onlyWithOwner =  false) {
    return axios({
        method: 'post',
        url: '/api/v1/companies/find',
        data: {
            query: text,
            withRealCompanies,
            onlyWithOwner,
        },
        withCredentials: true,
    });
}

export function findCompanyById(companyId) {
    return axios({
        method: 'get',
        url: `/api/v1/companies/${companyId}`,
        withCredentials: true,
    })
    .then(response => response.data.data)
    .catch(error => console.error(error));
}

export function approveUser(user) {
    return axios({
        method: 'put',
        url: `/api/v1/companies/${user.company._id}/members/${user.participantId || user._id}/approve`,
        data: {
            user,
        },
        withCredentials: true,
    })
    .then(response => {
        return response.data.data.message;
    })
    .catch(error => console.error(error));
}


export function disapproveUser(user) {
    return axios({
        method: 'put',
        url: `/api/v1/companies/${user.company._id}/members/${user.participantId || user._id}/disapprove`,
        data: {
            user,
        },
        withCredentials: true,
    })
    .then(response => {
        return response.data.data.message
    })
    .catch(error => console.error(error));
}

export function findMembersOfCompany({ _id, name = undefined }) {
    const data = {
        query: _id || name,
    };

    return axios({
        method: 'post',
        url: '/api/v1/companies/find-roles',
        data,
        withCredentials: true,
    })
    .then(response => response.data.data)
    .catch(error => console.error(error));
}

export function setNewParticipantsRoles(newParticipants, companyId) {
    return axios({
        method: 'put',
        url: '/api/v1/companies/update-roles',
        data: {
            query: {
                newParticipants,
                companyId,
            },
        },
        withCredentials: true,
    })
}

export function getCompanies() {
    return axios({
        method: 'get',
        url: '/api/v1/companies',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getRealCompanies() {
    return axios({
        method: 'get',
        url: '/api/v1/companies/realCompany/ifchor',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function findRealCompany(type, text) {
    return axios({
        method: 'post',
        url: `/api/v1/companies/realCompany/findRealCompanies/${type}`,
        data: {
            query: text,
        },
        withCredentials: true,
    });
}


export function saveRealCompany(parentId, realCompanyId) {
    return axios({
        method: 'put',
        url: `/api/v1/companies/realCompany/ifchor/${parentId}/${realCompanyId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function deleteRealCompany(companyId, companyIdToRemove) {
    return axios({
        method: 'delete',
        url: `/api/v1/companies/realCompany/ifchor/${companyId}/${companyIdToRemove}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/companies.js